<!-- 交易佣金 -->
 <!-- 球队管理 -->
<template>
    <div>
        <event-head></event-head>
        <div class="mt-3">
            <el-table :data="personinfo" style="width: 100%" :header-cell-style="{
                color: '#fff',
                fontSize: '14px',
                height: '40px',
                width: '100%',
            }">
                <el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
                <el-table-column prop="date" label="日期" align="center"></el-table-column>
                <el-table-column prop="allcount" label="交易总额" align="center"></el-table-column>
                <el-table-column prop="signcount" label="平台佣金" align="center"></el-table-column>
                <!-- <el-table-column prop="saascount" label="SaaS收益" align="center"></el-table-column> -->
                <el-table-column prop="count" label="佣金分成" align="center"></el-table-column>
            </el-table>
            <el-pagination layout="total, prev, pager, next" :current-page="pageInfo.page"
            :page-size="pageInfo.pageSize" :total="pageInfo.count"
            @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
        </div>
    </div>
</template>

<script>
import EventHead from '@/common/components/eventHead/EventHead';
export default {
    components: {
        EventHead
    },
    data() {
        return {
            pageInfo: {
                page: 1,
                pageSize: 10,
                count: 0,
            },
            personinfo:[{
                date:'2025-04-21',
                allcount:'¥100000',
                signcount:'¥5000',
                saascount:'¥111,238.00',
                count:'¥2500'
            }]

        };
    },
    mounted() {

    },
    methods: {


        handleSizeChange(val) {
            this.pageInfo.pageSize = val;
        },
        handleCurrentChange(val) {
            this.pageInfo.page = val;
        },

    },
};
</script>

<style lang="scss" scoped>
.cardinal {
    margin-top: 30px;
}

.addMatch {
    margin-left: 30px;
    font-size: 16px;
    color: #000;

}

/deep/.el-input--small .el-input__inner {
    height: 32px;
    line-height: 32px;
    background-color: transparent;
    opacity: 1;
    border: none;
    border-bottom: 1px solid #9b9b9b;
    color: #fff;
    border-radius: 0;
}

.bottom_btn {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 10px;

    .addVenue {
        color: #fff;
    }
}
</style>
<!-- <template>
    <div>
        <event-head></event-head>
        <div class="mt-3">
            <el-table :data="personinfo" style="width: 100%" :header-cell-style="{
                color: '#fff',
                fontSize: '14px',
                height: '40px',
                width: '100%',
            }">
                <el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
                <el-table-column prop="date" label="日期" align="center"></el-table-column>
                <el-table-column prop="allcount" label="交易总量" align="center"></el-table-column>
                <el-table-column prop="signcount" label="佣金收益" align="center"></el-table-column>
                <el-table-column prop="saascount" label="SaaS收益" align="center"></el-table-column>
                <el-table-column prop="count" label="合计收益" align="center"></el-table-column>
            </el-table>
            <el-pagination layout="total, prev, pager, next" :current-page="pageInfo.page"
            :page-size="pageInfo.pageSize" :total="pageInfo.count"
            @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
        </div>
    </div>
</template>

<script>
import EventHead from '@/common/components/eventHead/EventHead';
export default {
    components: {
        EventHead
    },
    data() {
        return {
            pageInfo: {
                page: 1,
                pageSize: 10,
                count: 0,
            },
            personinfo:[{
                date:'2025-04-21',
                allcount:'¥111,238.00',
                signcount:'¥238.00',
                saascount:'¥111,238.00',
                count:'¥111,238.00'
            }]

        };
    },
    mounted() {

    },
    methods: {


        handleSizeChange(val) {
            this.pageInfo.pageSize = val;
        },
        handleCurrentChange(val) {
            this.pageInfo.page = val;
        },

    },
};
</script>

<style lang="scss" scoped>
.cardinal {
    margin-top: 30px;
}

.addMatch {
    margin-left: 30px;
    font-size: 16px;
    color: #000;

}

/deep/.el-input--small .el-input__inner {
    height: 32px;
    line-height: 32px;
    background-color: transparent;
    opacity: 1;
    border: none;
    border-bottom: 1px solid #9b9b9b;
    color: #fff;
    border-radius: 0;
}

.bottom_btn {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 10px;

    .addVenue {
        color: #fff;
    }
}
</style> -->